<template>
    <div class="vod-webinar-author" v-if="content">
        <div class="webinar-author-description">
            <div class="about">
                O naszym gościu:
            </div>
            <h2>{{ content.author_name }}</h2>
            <p v-html="content.author_description" />
        </div>
        <div v-if="content.author_image" class="webinar-author-image">
            <img :src="content.author_image" />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        content: Object
    }
}
</script>
<style lang="scss" scoped>
p {
    max-width: 50rem;
    font-size: 1.2rem;
    line-height: 1.4rem;
    margin-top: 0;
}
h2 {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 2.5rem;
}
.vod-webinar-author {
    display: flex;
    margin-top: 5rem;
}
.webinar-author-description {
    flex: 3;
}
.webinar-author-image {
    flex: 1;
    img {
        width: 100%;
    }
}
@media (max-width: 1000px) {
    .vod-webinar-author {
        flex-direction: row;
        margin-top: 2rem;
    }
    .about {
        margin-bottom: 0.75rem;
        color: $accent-red;
        font-size: 1.1rem;
        font-family: $header-family;
    }
    .webinar-author-image {
        margin-top: 2rem;
    }
    h2 {
        font-size: 1.4rem;
        font-family: $input-family;
    }
    p {
        font-family: $input-family;
        color: $smoked;
        font-size: 1.2rem;
        line-height: 135%;
        margin-right: 0.4rem;
    }
}
</style>
